module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8